import FormikPhoneInput from './FormikPhoneInput';

export default FormikPhoneInput;
